import React, { useEffect, useState, useMemo } from "react";
import api from "api";
import SendPaymentLinkModal from './../modals/SendPaymentLinkModal'
import PaymentsListModal from './../modals/PaymentsListModal'
import AdminOrderModal from "./modals/AdminOrderModal";
import { download, debug, formatDate, formatPrice } from "utils";
import { FiDownload, FiRefreshCw, FiList, FiEdit2 } from "react-icons/fi";
import { HiOutlineCreditCard } from "react-icons/hi2";

export default function AdminOrdersList() {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
  const [showPaymentListModal, setShowPaymentListModal] = useState(false);

  const [showOrderModal, setShowOrderModal] = useState(false);
  const years = useMemo(() => {
    const list = [];
    for (let i = 0; i <= currentYear - 2026; i++) {
      list.push(currentYear - i);
    }
    return list;
  }, [currentYear]);
  const load = async () => {
    setLoading(true);
    setError(null);
    api
      .get("/admin/orders", {
        params: { year }
      })
      .then((res) => {
        setOrders(res.data || []);
      })
      .catch(() => {
        setError("Impossible de charger les commandes");
      })
      .finally(() => {
        setLoading(false);
      });
  }
  useEffect(() => {
    load();
  }, [year]);
  const handleSendPaymentLink = (order) => {
    setSelectedOrder(order);
    setShowPaymentLinkModal(true);
  };
  const handleDownload = (order) => {
    if (!order.orderPDFFilename) return;
    download(`/admin/orders/${order.orderId}/invoice/download`);
  };
  const handleShowPayments = (order) => {
    setSelectedOrder(order);
    setShowPaymentListModal(true);
  };
  const handleShowOrder = (order) => {
    setSelectedOrder(order);
    setShowOrderModal(true);
  };
  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="flex-grow-1"></div>
        <div className="d-flex justify-content-end align-items-center gap-2">
          <select
            className="form-select form-select-sm w-auto"
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
          >
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          <button className="btn btn-sm btn-outline-primary" onClick={load}>
            <FiRefreshCw />
          </button>
        </div>
      </div>
      {loading && <div>Chargement...</div>}
      {error && <div className="text-danger">{error}</div>}
      {!loading && !error && (
        <table className="table table-sm table-striped">
          <thead>
            <tr>
              <th>Numéro</th>
              <th>Date</th>
              <th className="text-start">Client</th>
              <th>HT</th>
              <th>TVA</th>
              <th>TTC</th>
              <th>SOLDE</th>
              <th>Facture</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  Aucune commande
                </td>
              </tr>
            )}
            {orders.map((order) => {
              const user = order.user || {};
              return (
                <tr key={order.orderId}>
                  <td className="text-center">{order.formatedInvoiceNumber || ''}</td>
                  <td className="text-center">{formatDate(order.orderDate || order.orderDate)}</td>
                  <td>
                    <div>
                      <strong>
                        {order.orderBillingLastname}{" "}
                        {order.orderBillingFirstname}
                      </strong>
                    </div>
                    {order.orderBillingCompany && (
                      <div>{order.orderBillingCompany}</div>
                    )}
                    <div className="small text-muted">
                      {user.userPhone}
                    </div>
                    <div className="small text-muted">
                      {order.orderBillingEmail}
                    </div>
                  </td>
                  <td className="text-center">{formatPrice(order.orderTotalPriceET)} €</td>
                  <td className="text-center">{formatPrice(order.orderVATRate)} €</td>
                  <td className="text-center">{formatPrice(order.orderTotalPriceIT)} €</td>
                  <td className={`text-center ${order.orderBalance > 0 ? 'text-danger' : 'text-primary'}`}>{formatPrice(order.orderBalance)} €</td>
                  <td className="text-end">
                    <div className="d-flex w-100 gap-3 justify-content-end">

                      <FiEdit2
                        className="text-primary"
                        size={16}
                        onClick={() => handleShowOrder(order)}
                        title="Voir la commande"
                      />

                      {order.orderBalance > 0 && (
                        <HiOutlineCreditCard className="text-danger" size={20} onClick={() => handleSendPaymentLink(order)} title="Envoyer un lien de paiement" />
                      )}
                      {order.orderBalance != order.orderTotalPriceIT && (
                        <FiList className="text-primary" size={20} onClick={() => handleShowPayments(order)} title="Liste des paiements reçus" />
                      )}
                      {order.orderPDFFilename && (
                        <FiDownload className="text-primary" size={20} onClick={() => handleDownload(order)} title="Télécharger la facture" />
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      {false && debug(orders[0])}
      <SendPaymentLinkModal
        show={showPaymentLinkModal}
        order={selectedOrder}
        onClose={() => setShowPaymentLinkModal(false)}
        onSuccess={() => {
          setShowPaymentLinkModal(false);
          // si tu veux refresh la liste plus tard
        }}
      />
      {showPaymentListModal &&
        <PaymentsListModal
          show={true}
          order={selectedOrder}
          onClose={() => setShowPaymentListModal(false)}
          onSuccess={() => {
            setShowPaymentListModal(false);
            // si tu veux refresh la liste plus tard
          }}
        />
      }
      {showOrderModal && (
        <AdminOrderModal
          show={true}
          order={selectedOrder}
          onClose={() => setShowOrderModal(false)}
        />
      )}
    </div>
  );
}